import SharedDocumentsLayout from '/@/modules/document/pages/SharedDocumentsLayout.vue';

export const router = [
  {
    path: '/',
    name: 'shareddocumentslayout',
    component: SharedDocumentsLayout,
    children: [
      {
        path: '/shared-documents',
        name: 'shared-documents',
        component: () => import('/@/modules/document/pages/SharedDocumentsPage.vue'),
        meta: { authOnly: false }
      }
    ]
  }
];
